import React,{Component} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import WysiwygEditor from '../../components/WysiwygEditor';
import AttachmentUpload from '../../components/AttachmentUpload';
import {AttachFile,Delete} from '@mui/icons-material';
import InboxApi from '../../api/inbox';
import {connect} from 'react-redux';
import {showError,showMessage} from '../../actions/uiActions';
import {IconButton} from '@mui/material';

class CustomEmail extends Component {

    state={
        message:"",
        subject:"",
        busy:false,
        attachments:[],
        from:"support@peoplejoy.co"
    }
    attachmentName=(name)=>{
      if(name.length<=30) {
        return name;
      } else {
        const pieces=name.split('.');
        return `${name.substring(0,20)}...${pieces[pieces.length-1]}`
      }
    }
    send=()=>{
      if(!this.state.subject) {
        this.props.showError("Please enter the email subject.");
      } else if(!this.state.message) {
        this.props.showError("Please enter the email message.")
      } else {
        this.setState({busy:true},async ()=>{
          try {
            await InboxApi.sendEmail(this.props.user,this.state.subject,this.state.message,this.state.attachments,this.state.from);
            this.props.showMessage("Email sent successfully!");
            this.props.onClose();
          } catch(error) {
            this.setState({ busy: false }, () => this.props.showError(error))
          }
        })
      }
    }
    render() {
        return <Dialog onClose={this.props.onCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description" open={true}
        >
        <DialogTitle id="alert-dialog-title">Send Email to User</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          <div className="form-group">
            <select className="form-control" value={this.state.from} onChange={e=>this.setState({from:e.target.value})}>
              <option value="support@peoplejoy.co">Send Email from support@peoplejoy.co</option>
              <option value={this.props.account.email}>Send Email from {this.props.account.email}</option>
            </select>
          </div>
            <div className="form-group">
              <input type="text" className="form-control" placeholder="Email Subject" value={this.state.subject} onChange={e=>this.setState({subject:e.target.value})} disabled={this.state.busy} /> 
            </div>
            <div className="form-group">
                <WysiwygEditor value={this.state.message} disabled={this.state.busy} onChange={e=>this.setState({message:e.target.value})} />
            </div>
            <div className="form-group">
              
              <ul className="email-attachments">
                {this.state.attachments.map((attachment,index)=><li key={`attachment-${index}`}>{this.attachmentName(attachment.filename)}<IconButton className="attachment-remove"><Delete /></IconButton></li>)}
              </ul>
              <AttachmentUpload name="file" onUpload={InboxApi.uploadAttachment} onChange={attachment=>this.setState({attachments:[...this.state.attachments,attachment]})}><span className="link-like"><AttachFile style={{fontSize:"14px"}} /> Attach file</span></AttachmentUpload>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" disabled={!this.state.subject||!this.state.message||this.state.busy} onClick={this.send} color="primary" autoFocus>
           {this.state.busy?"Sending email...":"Send Email"}
          </Button>
          {!this.state.busy&&<Button onClick={this.props.onClose} color="primary">
            Cancel
          </Button>}
        </DialogActions>
        </Dialog>;
    }
}
const mapStateToProps= state =>{
  return {
    account:state.auth.account
  }};
export default connect(mapStateToProps,{showError,showMessage})(CustomEmail);